import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { DmtUtilityService } from '../../../../../../services/dashboard/dmt-utility.service';
import { CommonModule } from '@angular/common';
import { TimelineEvolutionRegionalAccess } from '../../../../../../shared/interfaces/nt-EvolutionRegionalAccess.interface';
import { NtChartRegionInterface } from '../../../../../../shared/interfaces/nt-chart-region.interface';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-evolution-regional-access',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './evolution-regional-access.component.html',
  styleUrl: './evolution-regional-access.component.css'
})
export class EvolutionRegionalAccessComponent implements OnInit {
  @Output() isTwoRowLayout = new EventEmitter<boolean>();

  public medicineId: number = 0;
  public companyId: number = 0;
  public countryId: number = 1;
  public regionId: number = 0;
  public regionName?: string | null;
  stepSelected: string = '';
  hospitalOnekey: string = '';
  hasForecastData: boolean = false;
  hasActualData: boolean = false;
  isTwoRow:boolean=false;

  public chartData: NtChartRegionInterface = {
    labels: [],
    actual: [],
    real: [],
    target: []
  };

  timelineEvolution: TimelineEvolutionRegionalAccess[] = [];
  //isTwoRow:boolean=false;


  isLoadingTimeline: boolean = true;


  constructor(private dataService: DataService, private us: DmtUtilityService) { }

  ngOnInit(): void {
    this.isLoadingTimeline = true;
    this.getSessionVariables();
    this.getRegionalAccessEvolution();

    //this.getNationalChart();
  }

  getRegionalAccessEvolution(): void {
    this.dataService.getRegionalAccessEvolutionData(this.companyId, this.medicineId, this.countryId).subscribe(data => {
      this.timelineEvolution = data;

      this.hasForecastData = this.timelineEvolution.some(item => item.forecast?.length > 0);
      this.hasActualData = this.timelineEvolution.some(item => item.actual?.length > 0);
      let hasBoth = this.timelineEvolution.some(item =>
        item.actual?.length > 0 && item.forecast?.length > 0
      );

      this.isTwoRowLayout.emit(hasBoth);
      this.isLoadingTimeline=false;
    });
  }


  getSessionVariables() {
    this.regionName = sessionStorage.getItem('regionName') || '';
    this.medicineId = this.us.getSessionVariableNumber('medicineId', 0);
    this.countryId = this.us.getSessionVariableNumber('countryId');
    this.regionId = this.us.getSessionVariableNumber('regionId');
    this.companyId = this.us.getSessionVariableNumber('companyId', 0);
    this.stepSelected = sessionStorage.getItem('stepSelected') || '';
    this.hospitalOnekey = sessionStorage.getItem('hospitalOnekey') || '';
  }
}